<template>
  <div class="scrollable-element" ref="scrollable" v-if="quest !== null">
    <el-card class="box-card" style="margin: 10px 0 10px 0">
      <p v-for="(illustrate,index) in quest.illustrates" :key="index">{{ illustrate }}</p>
    </el-card>
    <el-progress class="fixed-element" :class="{ fixed: isFixed }"
                 :percentage="(100/quest.arrQuestion.length) * (questNumCollection.size - 1)"
                 :format="format"></el-progress>
    <el-card class="box-card">
      <h1 class="box-cardH" v-if="quest.questionTitle">{{ quest.questionTitle }}</h1>
      <Question v-for="(question,index) in filterQuestions" :question="question"
                :key="index + '' + question.num" :id="'question_' + question.num"
                v-on:listenToChildEvent="listenToChildEvent"></Question>
    </el-card>
    <el-button type="primary" class="large-btn" v-if="next" @click="toNext">下一页</el-button>
    <el-button type="primary" class="large-btn" v-else @click="submitDta" v-preventReClick>提交</el-button>
    <h1>&nbsp;</h1>
    <el-dialog :visible.sync="dialogVisible" title="以下特征，哪个是你期望的？" v-if="quest.forcedTopicSelection">
      <el-radio-group v-model="selectedOption">
        <div style="margin:2px 0" v-for="(item,i) in quest.forcedTopicSelection[0].options" :key="item.num">
          <el-radio :label=item.num class="radio-option" v-if="item.show===1" :id="i+''+item.num" :key="item.num">
            {{ item.option }}
          </el-radio>
        </div>
      </el-radio-group>
      <span slot="footer">
        <el-button type="primary" class="large-btn" @click="confirmSelection" style="margin: 5px;">确定</el-button>
        <el-button class="large-btn" @click="dialogVisible = false" style="margin: 5px;">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import HttpRequest from '@/utils/request'
import Question from '../components/Question'
import {getQuestByCode} from '@/assets/js/quest'
import {parseQuestNameByCode} from '@/assets/js/questIntro'
import {getSessionData, removeSessionData, setSessionData} from '@/utils/cache'

export default {
  components: {
    Question,
  },
  data() {
    return {
      quest: null,
      next: true,
      submit: false,
      currentPage: 1,
      questNumCollection: new Set([0]),
      answer: '',
      submitNum: 0,
      questCode: null,
      checkupId: null,
      type: null,
      questId: null,
      time: null,
      isFixed: false,
      dialogVisible: false,
      selectedOption: null,
      enneaIndex: ''
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student
    }),
    //过滤当前页面显示的问题
    filterQuestions() {
      return this.quest.arrQuestion.filter(question => question.page === this.currentPage)
    }
  },
  created() {
    this.getQuest()
  },
  mounted() {
    document.title = parseQuestNameByCode(this.questCode)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    //从缓存或者题本库获取题本的数据
    getQuest() {
      this.questCode = this.$route.query.questCode
      this.checkupId = this.$route.query.checkupId
      this.type = this.$route.query.type
      this.questId = this.$route.query.questId
      this.time = this.$route.query.time
      //从会话缓存中获取题本
      let questData = getSessionData(this.questCode + 'Quest')
      if (questData !== null && questData !== undefined) {
        this.quest = questData
        this.renderingProgress()
      } else {
        //从答卷库中获取答卷
        questData = getQuestByCode(this.questCode)
        if (questData !== null) {
          this.quest = questData
        } else {
          this.$alert('测评问卷不存在', {confirmButtonText: '返回', showClose: false}).then(() => {
            this.$router.go(-1)
          })
        }
      }
      if (this.quest !== null && this.currentPage === this.quest.arrQuestion[this.quest.arrQuestion.length - 1].page) {
        this.next = false
      }
    },
    //进度条显示 n/m 或 已完成
    format(percentage) {
      return percentage === 100 ? '已完成' : (this.questNumCollection.size - 1) + '/' + this.quest.arrQuestion.length
    },
    //渲染进度条
    renderingProgress() {
      for (let question of this.quest.arrQuestion) {
        if (question.finish === 1) {
          this.questNumCollection.add(question.num)
        }
      }
      this.$forceUpdate()
    },
    //监听子组件返回
    listenToChildEvent(num, answer, question) {
      if (num !== null && num !== undefined && question.finish === 1) {
        this.questNumCollection.add(num)
      } else {
        this.questNumCollection.delete(num)
      }
      this.$forceUpdate()
      // this.quest.arrQuestion[num - 1].answer = answer
      this.quest.arrQuestion[num - 1] = question
      setSessionData(this.questCode + 'Quest', this.quest)
    },
    //下一页
    toNext() {
      if (!this.confirmMust()) {
        return
      }
      if (this.currentPage < this.quest.arrQuestion[this.quest.arrQuestion.length - 1].page) {
        if (this.currentPage === this.quest.arrQuestion[this.quest.arrQuestion.length - 1].page - 1) {
          this.next = false
        }
        this.currentPage += 1
      }
    },
    //检查必答题是否已答题
    confirmMust() {
      for (let question of this.quest.arrQuestion) {
        question.errorMessage = ''
        if (question.page === this.currentPage && question.must === 1 && question.finish === 0) {
          question.errorMessage = question.mustFillMessage
          this.scrollToSection('question_' + question.num)
          return false
        }
      }
      return true
    },
    //跳转到指定位置
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId)
      if (section) {
        const offsetTop = section.offsetTop
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    },
    //九型人格
    handleResponse(res) {
      if (res.code === 300) {
        this.dialogVisible = true;
        let dataArray = res.data;
        let enneaOptions = this.quest.forcedTopicSelection[0].options;
        for (let i = 0; i < enneaOptions.length; i++) {
          if (dataArray.includes(enneaOptions[i].message)) {
            enneaOptions[i].show = 1;
          }
        }
        return true
      }
    },

    //提交保存
    submitDta() {
      if (this.questNumCollection.size - 1 < this.quest.arrQuestion.length) {
        if (!this.confirmMust()) {
          return
        }
      }
      if (this.submitNum === 0) {
        let answerArr = []
        for (let question of this.quest.arrQuestion) {
          answerArr.push(question.num + '$' + question.answer + '}')
        }
        this.answer = answerArr.join('').slice(0, -1)
        if (this.questCode == 'ennea') {
          this.answer += (this.selectedOption == null ? '' : '}37$' + this.selectedOption)
        }
        if ('occvalue' === this.questCode) {
          if (this.selectedOption === null) {
            this.occvalueJudge(this.answer)
            if (this.dialogVisible) {
              return
            }
          } else {
            this.answer += ('}21$' + this.selectedOption)
          }
        }
        let url = '/constub/saveAnswer'
        let data = {
          token: this.student.token,
          answer: this.answer,
          questCode: this.questCode,
          checkupId: this.checkupId,
          type: this.type,
          questId: this.questId
        };
        //如果是九型人格则传递参数增加一个随机下标
        if (this.questCode === 'ennea') {
          data.enneaIndex = this.quest.questIndex
        }
        HttpRequest.requestFormPost(url, data).then((res) => {
          if (res && res.result.success) {
            // this.$alert('保存成功',  {confirmButtonText: '确定',showClose: false,});
            //判断类型是否一样
            if (this.questCode === 'ennea' && this.handleResponse(res)) {
              return
            }
            removeSessionData(this.questCode + 'Quest')
            this.submitNum += 1
            let checkup = res.data
            //跳转
            this.changLink(checkup)
          } else {
            this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false})
          }
        })
      }
    },
    //进度条滚动到顶部后固定
    handleScroll() {
      const scrollableElement = this.$refs.scrollable
      this.isFixed = scrollableElement.getBoundingClientRect().top < 0
    },
    changLink(checkup) {
      let data = {
        questId: checkup.questId,
        questCode: checkup.questCode,
        time: checkup.updateTime
      }
      this.$router.push({
        path: ((getSessionData("partner") == null || getSessionData("partner") == undefined)
          ? 'simpleQuestFinish' : 'questFinish'), query: {data: JSON.stringify(data)}
      })
    },
    occvalueJudge(answer) {
      //技术型
      let technical = 0
      //服务型
      let serviceOriented = 0
      //自主型
      let autonomousType = 0
      //管理型
      let managementOriented = 0
      //生活型
      let lifestyle = 0
      //创造型
      let creativeDesign = 0
      //稳定型
      let stableType = 0
      //挑战型
      let challenging = 0
      //不清晰
      let unclear = 0


      let arrResult = answer.replace(/\d+\$/g, '').split('}')
      let myArray = [
        ['技术型', '创造型', '生活型', '管理型', '不清晰'],
        ['技术型', '生活型', '服务型', '挑战型', '不清晰'],
        ['服务型', '技术型', '管理型', '创造型', '不清晰'],
        ['自主型', '技术型', '挑战型', '管理型', '不清晰'],
        ['技术型', '稳定型', '管理型', '自主型', '不清晰'],
        ['技术型', '管理型', '创造型', '挑战型', '不清晰'],
        ['技术型', '挑战型', '稳定型', '服务型', '不清晰'],
        ['管理型', '服务型', '生活型', '稳定型', '不清晰'],
        ['自主型', '管理型', '技术型', '创造型', '不清晰'],
        ['管理型', '挑战型', '创造型', '服务型', '不清晰'],
        ['管理型', '创造型', '技术型', '服务型', '不清晰'],
        ['管理型', '生活型', '挑战型', '服务型', '不清晰'],
        ['生活型', '稳定型', '挑战型', '技术型', '不清晰'],
        ['自主型', '生活型', '稳定型', '挑战型', '不清晰'],
        ['自主型', '生活型', '稳定型', '创造型', '不清晰'],
        ['创造型', '稳定型', '自主型', '生活型', '不清晰'],
        ['自主型', '挑战型', '服务型', '稳定型', '不清晰'],
        ['创造型', '生活型', '自主型', '服务型', '不清晰'],
        ['创造型', '生活型', '自主型', '稳定型', '不清晰'],
        ['自主型', '挑战型', '服务型', '稳定型', '不清晰']
      ]


      for (let i = 0; i < arrResult.length; i++) {
        let value = myArray[i][arrResult[i] - 1]
        switch (value) {
          case '技术型' :
            technical += 1
            break
          case '服务型' :
            serviceOriented += 1
            break
          case '自主型' :
            autonomousType += 1
            break
          case '管理型' :
            managementOriented += 1
            break
          case '生活型' :
            lifestyle += 1
            break
          case '创造型' :
            creativeDesign += 1
            break
          case '稳定型' :
            stableType += 1
            break
          case '挑战型' :
            challenging += 1
            break
          case '不清晰' :
            unclear += 1
            break
        }
      }
      // 创建一个Map对象
      const myMap = new Map()
      myMap.set('技术型', technical)
      myMap.set('服务型', serviceOriented)
      myMap.set('自主型', autonomousType)
      myMap.set('管理型', managementOriented)
      myMap.set('生活型', lifestyle)
      myMap.set('创造型', creativeDesign)
      myMap.set('稳定型', stableType)
      myMap.set('挑战型', challenging)
      myMap.set('不清晰', unclear)
      // 将Map转换为数组并按照value排序
      const sortedArray = Array.from(myMap).sort((a, b) => b[1] - a[1])
      let options = this.quest.forcedTopicSelection[0].options
      //sortedArray[0][1];
      if (sortedArray[0][1] === (sortedArray[1][1])) {

        for (let i = 0; i < options.length; i++) {
          if (sortedArray[0][0] === (options[i].message)) {
            options[i].show = 1
          } else if (sortedArray[1][0] === (options[i].message)) {
            options[i].show = 1
          }
        }
        this.dialogVisible = true
        return false
      } else {
        return true
      }
    },
    confirmSelection() {
      if (this.selectedOption !== null) {
        this.dialogVisible = false
        this.submitDta()
      }
    }
  }
}
</script>

<style scoped>

.fixed-element {
  position: relative;
  background: #d0d7ee;
  z-index: 999;
  /* 初始样式 */
}

.fixed-element.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 10px;
  /* 固定在顶部的样式 */
}

.radio-option {
  font-size: 14px;
  margin-bottom: 10px;
}

.radio-group .el-radio {
  display: block;
  margin-bottom: 10px;
}

>>> .el-dialog {
  width: 90%;
}

>>> .el-radio, .el-radio__input {
  white-space: unset !important;
  line-height: 2;
}

.box-cardH {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
